export const getCurrentRoute = () => {
  let currentHref = window.location.href.split("/").slice(3).join("/");
  if (currentHref.indexOf("?") !== -1) {
    currentHref = currentHref.substring(0, currentHref.indexOf("?"));
  }
  return `/${currentHref}`;
};
